import { View } from 'react-native'
import { StyleSheet } from 'react-native-unistyles'

import NotFound from '@/components/shared/NotFound'
import UniButton from '@/components/unistyles/UniButton'
import UserEmail from '@/components/users/detail/settings/UserEmail'
import UserNotifications from '@/components/users/detail/settings/UserNotifications'
import UserProfile from '@/components/users/detail/settings/UserProfile'
import UserService from '@/services/userService'

const UserProfileSettings = () => {
  const { user, isLoading, currentOrganization } = UserService.useCurrentUser()
  const triggerRemindersMutation = UserService.useTriggerRemindersMutation()

  if (!isLoading && !user) return <NotFound />

  return (
    <View style={styles.cardContainer}>
      <UserProfile
        buttonMode="contained"
        buttonStyle={styles.button}
        formContainerStyle={styles.formContainer}
        titleStyle={styles.title}
      />
      <UserEmail
        buttonMode="contained"
        buttonStyle={styles.button}
        formContainerStyle={styles.formContainer}
        titleStyle={styles.title}
      />
      <UserNotifications
        buttonMode="contained"
        buttonStyle={styles.button}
        formContainerStyle={styles.formContainer}
        titleStyle={styles.title}
      />
      {__DEV__ && (
        <UniButton
          disabled={triggerRemindersMutation.isPending}
          mode="contained"
          onPress={() =>
            triggerRemindersMutation.mutate({
              organizationId: currentOrganization?.id || undefined,
            })
          }
        >
          Trigger Reminders for My Account
        </UniButton>
      )}
    </View>
  )
}

const styles = StyleSheet.create((theme) => ({
  button: {
    marginTop: theme.tokens.spacing[2],
    width: 200,
  },
  cardContainer: {
    gap: theme.tokens.spacing[8],
  },
  formContainer: {
    flexDirection: {
      md: 'row',
    },
    gap: theme.tokens.spacing[4],
  },
  title: {
    marginBottom: theme.tokens.spacing[4],
  },
}))

export default UserProfileSettings
